<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
  >
    <path d="M0 2C0 0.895431 0.89543 0 2 0H12C13.1046 0 14 0.895431 14 2V12C14 13.1046 13.1046 14 12 14H2C0.895431 14 0 13.1046 0 12V2ZM2 1C1.44772 1 1 1.44772 1 2V12C1 12.5523 1.44772 13 2 13H12C12.5523 13 13 12.5523 13 12V2C13 1.44772 12.5523 1 12 1H2ZM7.00006 3.00009C7.2762 3.00009 7.50006 3.22395 7.50006 3.50009V6.50009H10.5001C10.7762 6.50009 11.0001 6.72395 11.0001 7.00009C11.0001 7.27623 10.7762 7.50009 10.5001 7.50009H7.50006V10.5001C7.50006 10.7762 7.2762 11.0001 7.00006 11.0001C6.72392 11.0001 6.50006 10.7762 6.50006 10.5001V7.50009H3.50006C3.22392 7.50009 3.00006 7.27623 3.00006 7.00009C3.00006 6.72395 3.22392 6.50009 3.50006 6.50009H6.50006V3.50009C6.50006 3.22395 6.72392 3.00009 7.00006 3.00009Z" />
  </svg>
</template>
